import { gql } from '@apollo/client';

export const GET_PAGE_SIZE = gql`
  query getPageSize {
    # eslint-disable-next-line @graphql-eslint/require-id-when-available
    storeConfig {
      store_code
      grid_per_page
    }
  }
`;

export const GET_PRODUCT_FILTERS_BY_SEARCH = gql`
  query getProductFiltersBySearch($search: String!) {
    products(search: $search) {
      aggregations {
        label
        count
        attribute_code
        options {
          label
          value
          swatch_data {
            value
          }
          count
        }
        position
      }
    }
  }
`;

export const PRODUCT_SEARCH = gql`
  query ProductSearch(
    $currentPage: Int = 1
    $inputText: String!
    $pageSize: Int = 6
    $filters: ProductAttributeFilterInput!
    $sort: ProductAttributeSortInput
  ) {
    products(currentPage: $currentPage, pageSize: $pageSize, search: $inputText, filter: $filters, sort: $sort) {
      items {
        id
        uid
        name
        serial_name
        presale_product {
          status
          label
          note
        }
        price_range {
          maximum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
            discount {
              amount_off
            }
          }
          minimum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
            discount {
              amount_off
            }
          }
        }
        prices {
          finalPrice {
            currency
            value
          }
          regularPrice {
            currency
            value
          }
          ChildrenPrices {
            child_product_id
            sku
            finalPrice {
              currency
              value
            }
            regularPrice {
              currency
              value
            }
          }
        }
        sku
        hover_image(width: 680, height: 860)
        small_image {
          url
        }
        stock_status
        rating_summary
        review_count
        __typename
        url_key
        ... on ConfigurableProduct {
          variants {
            product {
              presale_product {
                status
                label
                note
              }
              uid
              stock_status
            }
          }
        }
      }
      page_info {
        total_pages
      }
      total_count
    }
  }
`;

export const GET_FILTER_INPUTS = gql`
  query GetFilterInputsForSearch {
    __type(name: "ProductAttributeFilterInput") {
      inputFields {
        name
        type {
          name
        }
      }
    }
  }
`;

export const GET_SEARCH_AVAILABLE_SORT_METHODS = gql`
  query getSearchAvailableSortMethods($search: String!) {
    products(search: $search) {
      sort_fields {
        options {
          label
          value
        }
      }
    }
  }
`;

export default {
  getFilterInputsQuery: GET_FILTER_INPUTS,
  getPageSize: GET_PAGE_SIZE,
  getProductFiltersBySearchQuery: GET_PRODUCT_FILTERS_BY_SEARCH,
  getSearchAvailableSortMethods: GET_SEARCH_AVAILABLE_SORT_METHODS,
  productSearchQuery: PRODUCT_SEARCH,
};
